import { render, staticRenderFns } from "./BaseInputTagNew.vue?vue&type=template&id=c74f6806"
import script from "./BaseInputTagNew.vue?vue&type=script&lang=js"
export * from "./BaseInputTagNew.vue?vue&type=script&lang=js"
import style0 from "./BaseInputTagNew.vue?vue&type=style&index=0&id=c74f6806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports